import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import arr_back from './back';
import { base_parse } from './nodes/html';
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */

export default function parse(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    lowerCaseTagName: false,
    comment: false
  };
  var stack = base_parse(data, options);

  var _stack = _slicedToArray(stack, 1),
      root = _stack[0];

  var _loop = function _loop() {
    // Handle each error elements.
    var last = stack.pop();
    var oneBefore = arr_back(stack);

    if (last.parentNode && last.parentNode.parentNode) {
      if (last.parentNode === oneBefore && last.tagName === oneBefore.tagName) {
        // Pair error case <h3> <h3> handle : Fixes to <h3> </h3>
        oneBefore.removeChild(last);
        last.childNodes.forEach(function (child) {
          oneBefore.parentNode.appendChild(child);
        });
        stack.pop();
      } else {
        // Single error  <div> <h3> </div> handle: Just removes <h3>
        oneBefore.removeChild(last);
        last.childNodes.forEach(function (child) {
          oneBefore.appendChild(child);
        });
      }
    } else {// If it's final element just skip.
    }
  };

  while (stack.length > 1) {
    _loop();
  } // response.childNodes.forEach((node) => {
  // 	if (node instanceof HTMLElement) {
  // 		node.parentNode = null;
  // 	}
  // });


  return root;
}